import type { TfClient } from '../client-internal';
import type { Database } from '../types.gen';

export type Tool = Database['public']['Tables']['tf_tools']['Row'];
export type ToolInsert = Database['public']['Tables']['tf_tools']['Insert'];

export interface ToolFilter {
  kind?: Tool['kind'];
  status?: Tool['status'];
  audience?: Tool['audience'];
}

export async function getTool(c: TfClient, slug: string): Promise<Tool | null> {
  const { data, error } = await c.from('tf_tools').select('*').eq('slug', slug).maybeSingle();
  if (error) throw error;
  return data;
}

export async function listTools(c: TfClient, filter: ToolFilter = {}): Promise<Tool[]> {
  let q = c.from('tf_tools').select('*').order('updated_at', { ascending: false });
  if (filter.kind) q = q.eq('kind', filter.kind);
  if (filter.status) q = q.eq('status', filter.status);
  if (filter.audience) q = q.eq('audience', filter.audience);
  const { data, error } = await q;
  if (error) throw error;
  return data ?? [];
}

export async function upsertTool(c: TfClient, input: ToolInsert): Promise<Tool> {
  const { data, error } = await c
    .from('tf_tools')
    .upsert(input, { onConflict: 'slug' })
    .select('*')
    .single();
  if (error) throw error;
  return data;
}
